import { AppConfiguration } from "@types";

const REG_PASSWORD = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

export const appConfig: AppConfiguration = {
  server: {
    baseURL: import.meta.env.VITE_API_BASE_URI as string,
  },
} as const;
